import { organizationId, platformChainIds } from 'utils/config';
import { useQuery } from 'react-query';
import { Polling } from 'utils/types';
import { fetchCollectionStats, fetchOwnedItems } from 'utils/platformPublicApi'

export const useOwnedItems = (address: string | null, queryConfig: any = {}) => {
  const { status, data, refetch } = useQuery(
    ['ownedItems', organizationId, address],
    () => {
      return fetchOwnedItems(organizationId, address!, platformChainIds.map(String));
    },
    {
      enabled: Boolean(address),
      refetchInterval: Polling.average,
      ...queryConfig,
    }
  );

  return {
    ownedItems: data || [],
    status,
    refetchOwnedItems: refetch,
  };
};

export const useCollectionStats = (collectionId: string) => {
  const { status, data }: any = useQuery(['collection', collectionId], () => {
    return fetchCollectionStats(collectionId);
  });

  return Boolean(data)
    ? {
        collectionStats: data.attributes,
        status,
      }
    : {
        collectionStats: [],
        status,
      };
};
